edgesLimit